export const FAVORITE_SITTER_ID_LOCAL_STORAGE_KEY = 'favoriteSitterId';
